import { grid } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '1 - 8x10',
  imageCount: 1,
  displayGroup: 'DG_8X10',
  calc: (height) => grid(1, 1, height)
};
